import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
// Api
import { PPV_TIERS } from 'api/streams/queries';
// Types
import { PpvTiers, PpvTiers_ppvTiers } from 'api/streams/types/PpvTiers';

export type PpvTier = PpvTiers_ppvTiers;

export const useGetPpvTiers = () => {
  const { data, loading, error, refetch } = useQuery<PpvTiers>(PPV_TIERS);

  const tiers = useMemo(
    () => [...(data?.ppvTiers ?? [])].sort((a, b) => a.price - b.price),
    [data]
  );

  return { tiers, loading, error: Boolean(error), refetch };
};
